// components/AcademicTable.js
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNotifications } from "./Dashboard/hooks/useNotifications";

const AcademicTable = () => {
    const { notifications, loading, handleNotificationClick } = useNotifications("Academics");

    return (
        <div className="container py-5">
            {/* Header */}
            <div
                className="text-white text-center mb-4 py-2"
                style={{
                    backgroundColor: "#77236b",
                    borderRadius: "12px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                }}
            >
                <h4 className="mb-0" style={{ fontWeight: "500" }}>
                    शैक्षणिक दिनदर्शिका
                </h4>
            </div>

            {/* Loading State */}
            {loading ? (
                <div className="text-center py-4">लोड हो रहा है...</div>
            ) : (
                <table className="table table-striped table-bordered">
                    <thead className="thead-dark">
                        <tr>
                            <th>सत्र का नाम</th>
                            <th>डाउनलोड</th>
                        </tr>
                    </thead>
                    <tbody>
                        {notifications.length > 0 ? (
                            notifications.map((session, index) => (
                                <tr key={index}>
                                    <td>{session.title_Hindi}</td>
                                    <td>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleNotificationClick(session)}
                                        >
                                            डाउनलोड करें
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="2" className="text-center">
                                    कोई सूचना नहीं मिली
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default AcademicTable;
